
// Generated from  Strings.cs

import {ApiRequestAsync} from "./ApiRequest";
import {Promise} from 'es6-promise';
import {InputType,InputText,InputNumber,InputBoolean,InputChoice,InputFile,InputDate,PrivilegeMembership,FileNote,LanguageInfo,RemoveQuery,FilterMode,ValueCaptionPair} from "./Shared";


export function getStringsAsync(language : string): Promise<Strings> {
  return ApiRequestAsync<Strings>('IStringsApi', 'GetStringsAsync', language);
}

export function getDocumentPrivilegeNamesAsync(language : string): Promise<string[]> {
  return ApiRequestAsync<string[]>('IStringsApi', 'GetDocumentPrivilegeNamesAsync', language);
}




import {observable, IObservableArray} from "mobx";

 
export class Strings {     
	@observable homepage: HomepageStrings = new HomepageStrings();    
	@observable language: LanguageInfo = new LanguageInfo();    
	@observable general: GeneralStrings = new GeneralStrings();    
	@observable settings: SettingsStrings = new SettingsStrings();    
	@observable sync: SyncStrings = new SyncStrings();    
	@observable appNavigation: AppNavigationStrings = new AppNavigationStrings();    
	@observable reader: ReaderStrings = new ReaderStrings();    
	@observable userManagement: UserManagementStrings = new UserManagementStrings();    
	@observable documentManagement: DocumentManagementStrings = new DocumentManagementStrings();    
	@observable metaManagement: MetaManagementStrings = new MetaManagementStrings();    
	@observable globalSettings: GlobalSettingsStrings = new GlobalSettingsStrings();    
	@observable favorites: FavoritesStrings = new FavoritesStrings();    
	@observable recentFiles: RecentFilesStrings = new RecentFilesStrings();    
	@observable datePicker: DatePickerStrings = new DatePickerStrings();
}
 
export class HomepageStrings {     
	@observable searchDocumentsTitle: string = "";    
	@observable readerTitle: string = "";    
	@observable recentFilesTitle: string = "";    
	@observable searchPlaceholder: string = "";    
	@observable favouriteDocumentsTitle: string = "";    
	@observable imprintTitle: string = "";    
	@observable legalNoticeTitle: string = "";    
	@observable privacyPolicyTitle: string = "";
}
 
export class SettingsStrings {     
	@observable title: string = "";    
	@observable portalsEditLabel: string = "";    
	@observable portalEditName: string = "";    
	@observable portalEditNamePlaceHolder: string = "";    
	@observable portalInformationTitle: string = "";    
	@observable portalUrlLabel: string = "";    
	@observable portalUrlPlaceholder: string = "";    
	@observable usernameLabel: string = "";    
	@observable usernamePlaceholder: string = "";    
	@observable passwordLabel: string = "";    
	@observable passwordPlaceholder: string = "";    
	@observable portalsAddLabel: string = "";    
	@observable portalsAddButtonTooltip: string = "";    
	@observable portalEditAreaAsideButtonExpandedTooltip: string = "";    
	@observable portalEditAreaAsideButtonCollapsedTooltip: string = "";
}
 
export class SyncStrings {     
	@observable syncTitle: string = "";    
	@observable syncPlaceholderTextforEmptyResult: string = "";    
	@observable syncButtonLabel: string = "";    
	@observable syncDeleteButtonLabel: string = "";
}
 
export class GeneralStrings {     
	@observable yes: string = "";    
	@observable no: string = "";    
	@observable ok: string = "";    
	@observable more: string = "";    
	@observable accept: string = "";   
	@observable cancel: string = "";    
	@observable next: string = "";    
	@observable saveButtonLabel: string = "";    
	@observable deleteButtonLabel: string = "";    
	@observable generalErrorMessage: string = "";    
	@observable saveSuccessMessage: string = "";    
	@observable saveErrorMessage: string = "";    
	@observable deleteSuccessMessage: string = "";    
	@observable errorDialogTitle: string = "";    
	@observable newTitle: string = "";    
	@observable languageChangedInformation: string = "";    
	@observable dialogDeleteTitle: string = "";    
	@observable dialogDeleteText: string = "";    
	@observable searchPlaceholder: string = "";    
	@observable localPortalLabel: string = "";    
	@observable documentAddLabel: string = "";    
	@observable filesAddLabel: string = "";    
	@observable clickToAddImageText: string = "";    
	@observable keepOnPageDialogTitle: string = "";    
	@observable keepOnPageDialogText: string = "";    
	@observable onLeaveDialogTitle: string = "";    
	@observable onLeaveDialogText: string = "";    
	@observable appAreaAsideLabel: string = "";    
	@observable logIn: string = "";    
	@observable download: string = "";    
	@observable collapseButtonTooltip: string = "";    
	@observable expandButtonTooltip: string = "";    
	@observable refreshButtonTooltip: string = "";    
	@observable closeButtonTooltip: string = "";    
	@observable editButtonTooltip: string = "";    
	@observable closeNode: string = "";    
	@observable expandNode: string = "";    
	@observable searchButtonTooltip: string = "";    
	@observable loading: string = "";    
	@observable invariantLanguageCaption: string = "";    
	@observable invariantLanguageRegion: string = "";    
	@observable timeoutErrorMessage: string = "";    
	@observable sessionTimeoutErrorMessage: string = "";
	@observable searchSpecialCharacterInEpub: string = "";
}
 
export class AppNavigationStrings {     
	@observable homeLinkText: string = "";    
	@observable readerTitle: string = "";    
	@observable favoriteLinkText: string = "";    
	@observable readerLinkText: string = "";    
	@observable documentManagerTitle: string = "";    
	@observable collectionsLinkText: string = "";    
	@observable metaDataLinkText: string = "";    
	@observable searchDocumentsLinkText: string = "";    
	@observable administrationTitle: string = "";    
	@observable userLinkText: string = "";    
	@observable userProfileLinkText: string = "";    
	@observable changePasswordLinkText: string = "";    
	@observable logOutLinkText: string = "";    
	@observable aboutLinkText: string = "";    
	@observable groupsLinkText: string = "";    
	@observable syncLinkText: string = "";    
	@observable settingsLinkText: string = "";    
	@observable languageSettingsLinkText: string = "";    
	@observable brandingSettingsLinkText: string = "";    
	@observable translationLinkText: string = "";    
	@observable recentFilesLinkText: string = "";    
	@observable portalSettingsLinkText: string = "";    
	@observable userButtonTooltip: string = "";    
	@observable backButtonTooltip: string = "";    
	@observable mainNavigationButtonTooltip: string = "";
}
 
export class ReaderStrings {     
	@observable title: string = "";    
	@observable readerPlaceholderTextforEmptyResult: string = "";    
	@observable addAdditionalFilterValuesText: string = "";    
	@observable resultSetSizeTextSingle: string = "";    
	@observable resultSetSizeTextMultiple: string = "";    
	@observable searchingText: string = "";    
	@observable metaInfoBoxTitle: string = "";    
	@observable highlightAllText: string = "";    
	@observable matchCaseText: string = "";    
	@observable areaAsideButtonExpandedTooltip: string = "";    
	@observable areaAsideButtonCollapsedTooltip: string = "";    
	@observable editButtonTooltip: string = "";    
	@observable readerAreaAsideButtonExpandedTooltip: string = "";    
	@observable readerAreaAsideButtonCollapsedTooltip: string = "";    
	@observable downloadButtonTooltip: string = "";    
	@observable downloadButtonWaitingTooltip: string = "";    
	@observable downloadButtonDownloadingTooltip: string = "";    
	@observable downloadButtonOfflineTooltip: string = "";    
	@observable downloadButtonErrorTooltip: string = "";    
	@observable downloadButtonUpdateTooltip: string = "";    
	@observable addFavoriteButtonTooltip: string = "";    
	@observable removeFavoriteButtonTooltip: string = "";    
	@observable fullScreenDisableButtonTooltip: string = "";    
	@observable fullScreenEnableButtonTooltip: string = "";    
	@observable viewListButtonTooltip: string = "";    
	@observable viewCardButtonTooltip: string = "";    
	@observable pagePreviousButtonTooltip: string = "";    
	@observable pageNextButtonTooltip: string = "";    
	@observable rotateClockwiseButtonTooltip: string = "";    
	@observable rotateCounterClockwiseButtonTooltip: string = "";    
	@observable resetFiltersButtonTooltip: string = "";    
	@observable searchBarHideButtonTooltip: string = "";    
	@observable searchBarShowButtonTooltip: string = "";    
	@observable searchPreviousButtonTooltip: string = "";    
	@observable searchNextButtonTooltip: string = "";    
	@observable zoomInButtonTooltip: string = "";    
	@observable zoomOutButtonTooltip: string = "";    
	@observable fontSizeIncreaseButtonTooltip: string = "";    
	@observable fontSizeDecreaseButtonTooltip: string = "";    
	@observable handButtonTooltip: string = "";    
	@observable infoButtonTooltip: string = "";    
	@observable imageReszing: string = "";    
	@observable fitToWindowButtonTooltip: string = "";    
	@observable originalSizeButtonTooltip: string = "";    
	@observable validFromHeader: string = "";    
	@observable validUntilHeader: string = "";    
	@observable deepLinkNotFoundText: string = "";    
	@observable deepLinkNotFoundTitle: string = "";    
	@observable createDeepLinkTitle: string = "";    
	@observable yourGeneratedDeepLink: string = "";    
	@observable deepLinkDescription: string = "";    
	@observable copyDeepLinkButtonTitle: string = "";    
	@observable shareDeepLinkButtonTooltip: string = "";    
	@observable typeAheadNoResults: string = "";    
	@observable sendFeedbackTitle: string = "";    
	@observable subjectLabel: string = "";    
	@observable messageLabel: string = "";    
	@observable send: string = "";    
	@observable mailSendingError: string = "";
}
 
export class FavoritesStrings {     
	@observable favouritePlaceholderTextforEmptyResult: string = "";
}
 
export class RecentFilesStrings {     
	@observable recentFilesPlaceholderTextforEmptyResult: string = "";
}
 
export class UserManagementStrings {     
	@observable users: UsersStrings = new UsersStrings();    
	@observable userEdit: UserEditStrings = new UserEditStrings();    
	@observable userProfile: UserProfileStrings = new UserProfileStrings();    
	@observable groups: GroupsStrings = new GroupsStrings();    
	@observable groupEdit: GroupEditStrings = new GroupEditStrings();
}
 
export class UsersStrings {     
	@observable title: string = "";    
	@observable searchPlaceholder: string = "";    
	@observable addUserTitle: string = "";    
	@observable lockedUserTooltip: string = "";    
	@observable myUserTooltip: string = "";    
	@observable addButtonTooltip: string = "";
}
 
export class UserEditStrings {     
	@observable generalInformationTitle: string = "";    
	@observable nameLabel: string = "";    
	@observable namePlaceholder: string = "";    
	@observable passwordLabel: string = "";    
	@observable passwordConfirmationLabel: string = "";    
	@observable statusTitle: string = "";    
	@observable lockedLabel: string = "";    
	@observable expirationLabel: string = "";    
	@observable memberOfTitle: string = "";    
	@observable generalCaption: string = "";    
	@observable privilegeCaption: string = "";    
	@observable displayNameLabel: string = "";    
	@observable emailLabel: string = "";    
	@observable uiLanguageLabel: string = "";    
	@observable resetPasswordButtonLabel: string = "";    
	@observable resetPasswordSuccess: string = "";    
	@observable resetPasswordFailure: string = "";    
	@observable areaAsideButtonExpandedTooltip: string = "";    
	@observable areaAsideButtonCollapsedTooltip: string = "";    
	@observable addButtonTooltip: string = "";
}
 
export class UserProfileStrings {     
	@observable generalInformationTitle: string = "";    
	@observable changePasswordTitle: string = "";    
	@observable nameLabel: string = "";    
	@observable namePlaceholder: string = "";    
	@observable displayNameLabel: string = "";    
	@observable emailLabel: string = "";    
	@observable uiLanguageLabel: string = "";    
	@observable oldPasswordLabel: string = "";    
	@observable newPasswordLabel: string = "";    
	@observable newPasswordConfirmationLabel: string = "";    
	@observable cannotChangeAnonymousPassword: string = "";
}
 
export class GroupsStrings {     
	@observable title: string = "";    
	@observable searchPlaceholder: string = "";    
	@observable addGroupsTitle: string = "";    
	@observable addButtonTooltip: string = "";
}
 
export class GroupEditStrings {     
	@observable generalInformationTitle: string = "";    
	@observable nameLabel: string = "";    
	@observable namePlaceholder: string = "";    
	@observable systemPrivilegesTitle: string = "";    
	@observable memberOfTitle: string = "";    
	@observable generalCaption: string = "";    
	@observable areaAsideButtonExpandedTooltip: string = "";    
	@observable areaAsideButtonCollapsedTooltip: string = "";
}
 
export class DocumentManagementStrings {     
	@observable collections: CollectionsStrings = new CollectionsStrings();    
	@observable collectionEdit: CollectionEditStrings = new CollectionEditStrings();    
	@observable documentEdit: DocumentEditStrings = new DocumentEditStrings();    
	@observable fileEdit: FileEditStrings = new FileEditStrings();
}
 
export class CollectionsStrings {     
	@observable title: string = "";    
	@observable documentCaption: string = "";    
	@observable privilegesCaption: string = "";    
	@observable moveCollectionCaption: string = "";    
	@observable moveCollectionText: string = "";    
	@observable moveCollectionRootName: string = "";    
	@observable addButtonTooltip: string = "";    
	@observable selectionButtonTooltip: string = "";    
	@observable moveButtonTooltip: string = "";    
	@observable deleteButtonTooltip: string = "";    
	@observable deleteMultipleCollectionsDialogTitle: string = "";    
	@observable deleteMultipleCollectionsDialogText: string = "";    
	@observable showSearchButtonTooltip: string = "";    
	@observable hideSearchButtonTooltip: string = "";    
	@observable findPreviousButtonTooltip: string = "";    
	@observable findNextButtonTooltip: string = "";    
	@observable resultSetSizeTextSingle: string = "";    
	@observable resultSetSizeTextMultiple: string = "";
}
 
export class CollectionEditStrings {     
	@observable title: string = "";    
	@observable addTitle: string = "";    
	@observable generalInformationTitle: string = "";    
	@observable nameLabel: string = "";    
	@observable namePlaceholder: string = "";    
	@observable collectionEmptyPrivilegeResultText: string = "";    
	@observable collectionEmptyDocumentResultText: string = "";    
	@observable addPrivilegesCaption: string = "";    
	@observable addPrivilegesText: string = "";    
	@observable areaAsideButtonExpandedTooltip: string = "";    
	@observable areaAsideButtonCollapsedTooltip: string = "";    
	@observable moveButtonTooltip: string = "";    
	@observable documentsAddButtonTooltip: string = "";    
	@observable documentsSelectionButtonTooltip: string = "";    
	@observable documentsMoveButtonTooltip: string = "";    
	@observable documentsDeleteButtonTooltip: string = "";    
	@observable deleteMultipleDocumentsDialogTitle: string = "";    
	@observable deleteMultipleDocumentsDialogText: string = "";    
	@observable deletePrivilegesDialogTitle: string = "";    
	@observable deletePrivilegesDialogText: string = "";
}
 
export class MetaManagementStrings {     
	@observable metas: MetasStrings = new MetasStrings();    
	@observable metaEdit: MetaEditStrings = new MetaEditStrings();    
	@observable translation: TranslationStrings = new TranslationStrings();
}
 
export class MetasStrings {     
	@observable title: string = "";    
	@observable saveSortOrderTitle: string = "";    
	@observable saveSortOrderText: string = "";    
	@observable addButtonTooltip: string = "";    
	@observable moveButtonTooltip: string = "";    
	@observable predefinedMetaIconTooltip: string = "";
}
 
export class MetaEditStrings {     
	@observable title: string = "";    
	@observable dataType: string = "";    
	@observable id: string = "";
	@observable iirdsId: string = "";    
	@observable caption: string = "";    
	@observable idPlaceHolder: string = "";
	@observable iirdsIdPlaceHolder: string = "";    
	@observable captionPlaceHolder: string = "";    
	@observable regex: string = "";    
	@observable regexPlaceHolder: string = "";    
	@observable preDefined: string = "";    
	@observable multiple: string = "";    
	@observable required: string = "";    
	@observable languageDependent: string = "";    
	@observable showAsColumn: string = "";    
	@observable showAsFilter: string = "";    
	@observable showAsInfo: string = "";    
	@observable preDefinedValues: string = "";    
	@observable filterMaxValues: string = "";    
	@observable filterMaxValuesPlaceHolder: string = "";    
	@observable filterMode: string = "";    
	@observable addMetaTitle: string = "";    
	@observable generalCaption: string = "";    
	@observable functionalityCaption: string = "";    
	@observable definitionCaption: string = "";    
	@observable metaEditEmptyPredefinedValuesResultText: string = "";    
	@observable areaAsideButtonExpandedTooltip: string = "";    
	@observable areaAsideButtonCollapsedTooltip: string = "";    
	@observable valuesAddButtonTooltip: string = "";    
	@observable valuesMoveButtonTooltip: string = "";    
	@observable valuesRemoveButtonTooltip: string = "";    
	@observable hierarchyBlankBeforeNodeName: string = "";    
	@observable hierarchyBlankLine: string = "";    
	@observable hierarchySkippedLevel: string = "";    
	@observable hierarchyEmptyNodeName: string = "";    
	@observable hierarchyInvalidCharacter: string = "";    
	@observable hierarchyNoValuesText: string = "";    
	@observable hierarchyNoValuesLevel: string = "";
}
 
export class TranslationStrings {     
	@observable title: string = "";    
	@observable translationExportTitle: string = "";    
	@observable translationSourceLanguageLabel: string = "";    
	@observable translationTargetLanguageLabel: string = "";    
	@observable translationDownloadButtonLabel: string = "";    
	@observable translationImportTitle: string = "";    
	@observable translationImportFlagsCaption: string = "";    
	@observable translationUploadFileLabel: string = "";    
	@observable translationSubmitButtonLabel: string = "";    
	@observable translationSourceLanguageInvalid: string = "";    
	@observable translationTargetLanguageInvalid: string = "";    
	@observable translationImportSuccess: string = "";    
	@observable translationImportError: string = "";    
	@observable translationImportFileError: string = "";    
	@observable xliffImportFlags: XliffImportFlagsStrings = new XliffImportFlagsStrings();
}
 
export class DocumentEditStrings {     
	@observable id: string = "";    
	@observable idPlaceHolder: string = "";    
	@observable name: string = "";    
	@observable namePlaceHolder: string = "";    
	@observable documentTitle: string = "";    
	@observable addTitle: string = "";    
	@observable filesTitle: string = "";    
	@observable documentEmptyFilesResultText: string = "";
	@observable newDocumentEmptyFilesResultText: string = "";  
	@observable documentEmptyMetaResultText: string = "";    
	@observable documentEmptyPrivilegeResultText: string = "";    
	@observable addPrivilegesCaption: string = "";    
	@observable addPrivilegesText: string = "";    
	@observable addMetaDataCaption: string = "";    
	@observable addMetaDataText: string = ""; 
	@observable addMetaDataDocumentLinkCaption: string = "";
	@observable addMetaDataDocumentLinkText: string = ""; 
	@observable addSelectedDocumentLink: string = "";
	@observable addHierarchicalMetaValueCaption: string = "";    
	@observable addHierarchicalMetaValueText: string = "";    
	@observable moveDocumentsCaption: string = "";    
	@observable moveDocumentsText: string = "";    
	@observable exceptionFileTypeNotSupported: string = "";    
	@observable privilegesAddButtonTooltip: string = "";    
	@observable privilegesSelectionButtonTooltip: string = "";    
	@observable privilegesDeleteButtonTooltip: string = "";    
	@observable metasAddButtonTooltip: string = "";    
	@observable metasSelectionButtonTooltip: string = "";    
	@observable metasDeleteButtonTooltip: string = "";    
	@observable metasRemoveButtonTooltip: string = "";    
	@observable metasEditButtonTooltip: string = "";    
	@observable metasAddValueButtonTooltip: string = "";    
	@observable fileManagementButtonTooltip: string = "";    
	@observable metasEditDocumentButtonTooltip: string = "";    
	@observable metasDocumentDeleted: string = "";    
	@observable addSelectedValues: string = "";    
	@observable addSelectedDocuments: string = "";
	@observable readerNameHeader:string = "";
}
 
export class FileEditStrings {     
	@observable title: string = "";    
	@observable addButtonTooltip: string = "";    
	@observable selectionButtonTooltip: string = "";    
	@observable deleteButtonTooltip: string = "";    
	@observable editNameButtonTooltip: string = "";    
	@observable filterButtonTooltip: string = "";    
	@observable filterButtonTooltipPressed: string = "";    
	@observable deleteMultipleFilesDialogTitle: string = "";    
	@observable deleteMultipleFilesDialogText: string = "";    
	@observable uploadSecondFileDialogTitle: string = "";    
	@observable uploadSecondFileDialogText: string = "";    
	@observable characterLimitErrorMessage: string = "";    
	@observable fileTooltip: string = "";    
	@observable readerButtonTooltip: string = "";    
	@observable selectLanguageCaption: string = "";    
	@observable selectLanguageText: string = "";    
	@observable changeLanguageButtonTooltip: string = "";
}
 
export class GlobalSettingsStrings {     
	@observable brandingEdit: BrandingEditStrings = new BrandingEditStrings();    
	@observable languageSettings: LanguageSettingsEditStrings = new LanguageSettingsEditStrings();
}
 
export class BrandingEditStrings {     
	@observable title: string = "";    
	@observable previewTitle: string = "";    
	@observable colorPickerButtonTitle: string = "";
	@observable colorPickerRedLabel: string = "";
	@observable colorPickerGreenLabel: string = "";
	@observable colorPickerBlueLabel: string = "";
}
 
export class LanguageSettingsEditStrings {     
	@observable title: string = "";    
	@observable filterLabel: string = "";    
	@observable showSelectedLabel: string = "";    
	@observable listHeaderNameTitle: string = "";    
	@observable listHeaderInterfaceTitle: string = "";    
	@observable listHeaderContentTitle: string = "";
}
 
export class XliffImportFlagsStrings {     
	@observable ignoreApproved: string = "";    
	@observable ignoreState: string = "";    
	@observable ignoreSourceTimeStamp: string = "";    
	@observable ignoreTargetTimeStamp: string = "";
}
 
export class DatePickerStrings {     
	@observable sunday: string = "";    
	@observable monday: string = "";    
	@observable tuesday: string = "";    
	@observable wednesday: string = "";    
	@observable thursday: string = "";    
	@observable friday: string = "";    
	@observable saturday: string = "";    
	@observable january: string = "";    
	@observable february: string = "";    
	@observable march: string = "";    
	@observable april: string = "";    
	@observable may: string = "";    
	@observable june: string = "";    
	@observable july: string = "";    
	@observable august: string = "";    
	@observable september: string = "";    
	@observable october: string = "";    
	@observable november: string = "";    
	@observable december: string = "";
}



export function _ignoreCompilerError_TS6133(x: any) : boolean {
  return (x instanceof InputText) || 
		 (x instanceof InputBoolean) || 
		 (x instanceof InputChoice) || 
		 (x instanceof InputDate) ||
		 (x instanceof InputFile) || 
		 (x instanceof PrivilegeMembership) || 
		 (x instanceof FileNote) || 
		 (x instanceof LanguageInfo) || 
		 (x instanceof RemoveQuery);
}

